export const PAGES = Object.freeze({
  LOGIN: '/login',
  HORIZONTAL_TILES: '/',
  VERTICAL_TILES: '/vertical-tiles',
  PLAY: '/play',
  DRILLS: '/drills',
  COACH: '/coach',
  TOUR_TRASH: '/misc/tour-trash',
  GRAPHICS: {
    HOME: '/graphics/home',
    PLAY: '/graphics/play',
    DRILLS: '/graphics/drills',
    COACH: '/graphics/coach',
    SHOP: '/graphics/shop',
    OTHER: '/graphics',
    TEXT: '/graphics/text',
    FITTING: '/graphics/fitting',
  },
  VIDEO: '/video',
  TEXT: '/text',
  EXTERNAL_TOOLS: '/external-tools',
  SERVER_HEALTH: '/server-health',
  ACTIVITY_LOG: '/activity-log',
  PROMOTION: '/promotion',
  PERKS: '/perks',
  PRODUCT: '/product',
  LAUNCH_FEATURES: '/launch-features',
  SHOW_HIDE_FEATURES: '/show-hide-features',
  PAID_FEATURES: '/paid-features',
  ACCESS_CODE: '/access-code',
  LOYALTY_ACTION: '/loyalty-action',
  MY_GAME_PROFILE: '/my-game-profile',
  TRY_THEN_BUY: '/try-then-buy',
  TRY_THEN_BUY_FRAUD: '/try-then-buy-fraud',
  TOS: '/terms-of-service',
  PERMISSION: '/permission-denied',
  USER_PROFILE: '/user-profile',
  PRODUCT_TILE: '/marquee-tile',
  MORE_FOR_YOU: '/product-carousel',
  CATEGORIES: '/shop-categories',
  PRODUCT_CATALOG: '/product-catalog',
  MAINSTAYS: '/mainstays',
  PLAY_BG_IMAGE: '/play/images',
  CLUB_HOUSE: {
    JUST_IN: '/club/just-in',
    COLLECTION: '/club/collection',
    PLAYER: '/club/player-coach',
    TOUR_STORY: '/club/tour-stories',
  },
  HOME: {
    FOLDER: {
      THE_DAILY: '/home/daily',
      POINTS: '/home/points',
      PERKS: '/home/perks',
    },
    TOP_STORY: '/home/top-story',
    DRILL_OF_WEEK: '/home/drill',
    PRODUCT: '/home/product',
    CARTNER_CONVOS: '/home/cartner-convos',
  },
});
